import type { Payment } from 'helpers/types';
import { AlertStatus, OfferStatus } from 'helpers/enums';
import { mapOffer } from 'services/order/helpers';
import { parseAttachments } from 'helpers/attachments';

export const mapPayment = ({
  id,
  subject,
  user,
  field,
  term,
  penaltyDays,
  penaltyAmount,
  offers,
  paymentDocuments,
}: any): Payment => {
  const price = offers
    ? offers.filter((n: any) => n.status !== OfferStatus.canceled).map(mapOffer).price
    : 0;
  const paymentDocumentsParsed = paymentDocuments ? parseAttachments(paymentDocuments) : [];

  return {
    id,
    title: subject,
    user: user
      ? {
          id: user.id,
          name: user.user.name,
          profilePhoto: null,
        }
      : null,
    label: field ? field.name : null,
    price,
    term,
    delay: penaltyDays || 0,
    penalty: penaltyAmount || 0,
    toPay: Number.parseInt(price || 0, 10) + Number.parseInt(penaltyAmount || 0, 10),
    paymentDocuments: paymentDocumentsParsed,
    badges: !paymentDocumentsParsed.length
      ? [
          {
            title: 'Oczekuje na fakturę',
            status: AlertStatus.success,
          },
        ]
      : [],
  };
};
